import {fetchData, sendData} from "../../global-declare-components/api/network";

const quickRegistrationAPI = {
  fetchQuickRegistration:(slug) => fetchData(`/api/landing-page/${slug}/quick-registration`),
  quickRegistration:(slug, data) => sendData(`/api/landing-page/${slug}/quick-registration`, data)
};

export default quickRegistrationAPI;
